import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f0f23 100%);
  padding: 64px 80px;
  overflow: hidden;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 48px;
`;

export const LogoImage = styled.img`
  height: 96px;
  width: auto;
  object-fit: contain;
`;

export const Content = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h1`
  font-size: 56px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  margin-bottom: 16px;
`;

export const Subtitle = styled.p`
  font-size: 32px;
  color: #b0b0b0;
  text-align: center;
  margin-bottom: 64px;
`;

export const ActivationURL = styled.span`
  color: #4fc3f7;
  font-weight: 500;
`;

export const StepsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 160px;
  width: 100%;
  max-width: 1400px;
`;

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;
  max-width: 500px;
`;

export const StepNumber = styled.div`
  font-size: 200px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.05);
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 0;
  user-select: none;
  pointer-events: none;
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
  padding-top: 40px;
`;

export const StepLabel = styled.p`
  font-size: 28px;
  color: #b0b0b0;
  text-align: center;
  margin-bottom: 8px;
`;

export const StepURL = styled.p`
  font-size: 32px;
  font-weight: 600;
  color: #4fc3f7;
  margin-bottom: 32px;
`;

export const QRCodeWrapper = styled.div`
  background: #ffffff;
  padding: 24px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PairingCode = styled.div`
  font-size: 80px;
  font-weight: 700;
  color: #4fc3f7;
  letter-spacing: 12px;
  font-family: 'Roboto Mono', monospace;
  margin-top: 24px;
`;

export const ExpirationTimer = styled.p`
  font-size: 24px;
  color: #757575;
  margin-top: 24px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;

export const LoadingSpinner = styled.div`
  width: 64px;
  height: 64px;
  border: 4px solid rgba(79, 195, 247, 0.2);
  border-top-color: #4fc3f7;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const LoadingText = styled.p`
  font-size: 32px;
  color: #b0b0b0;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const ErrorText = styled.p`
  font-size: 32px;
  color: #f44336;
  text-align: center;
`;

export const RetryButton = styled.button`
  font-size: 32px;
  font-weight: 500;
  color: #ffffff;
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  padding: 20px 48px;
  border-radius: 12px;
  transition: all 150ms ease-in-out;

  &:focus {
    transform: scale(1.05);
    box-shadow: 0 0 0 4px rgba(79, 195, 247, 0.5);
  }

  &:hover {
    background: linear-gradient(135deg, #42a5f5 0%, #2196f3 100%);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  padding-top: 32px;
  width: 100%;
`;

export const DeviceInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  p {
    font-size: 24px;
    color: #505050;
    margin: 0;
  }
`;

export const DevSkipButton = styled.button`
  font-size: 24px;
  font-weight: 500;
  color: #ffc107;
  background: rgba(255, 193, 7, 0.1);
  border: 2px solid rgba(255, 193, 7, 0.3);
  padding: 12px 24px;
  border-radius: 8px;
  transition: all 150ms ease-in-out;

  &:hover {
    background: rgba(255, 193, 7, 0.2);
    border-color: rgba(255, 193, 7, 0.5);
  }

  &:focus {
    transform: scale(1.05);
    box-shadow: 0 0 0 4px rgba(255, 193, 7, 0.3);
  }
`;

// ===========================================================================
// PENDING APPROVAL STYLES
// ===========================================================================

export const PendingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  padding: 48px;
  max-width: 800px;
`;

export const LockIcon = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: rgba(79, 195, 247, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 64px;
    height: 64px;
    fill: #4fc3f7;
  }
`;

export const PendingTitle = styled.h2`
  font-size: 48px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  margin: 0;
`;

export const DeviceIdDisplay = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: #4fc3f7;
  font-family: 'Roboto Mono', monospace;
  letter-spacing: 2px;
  background: rgba(79, 195, 247, 0.1);
  padding: 16px 32px;
  border-radius: 12px;
  border: 2px solid rgba(79, 195, 247, 0.3);
`;

export const DeviceModel = styled.p`
  font-size: 28px;
  color: #b0b0b0;
  margin: 0;
`;

export const PendingMessage = styled.p`
  font-size: 28px;
  color: #b0b0b0;
  text-align: center;
  line-height: 1.5;
  max-width: 600px;
`;

export const PendingSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 3px solid rgba(79, 195, 247, 0.2);
  border-top-color: #4fc3f7;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const PendingStatus = styled.div`
  font-size: 24px;
  color: #757575;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const RejectedIcon = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: rgba(244, 67, 54, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 64px;
    height: 64px;
    fill: #f44336;
  }
`;

export const RejectedTitle = styled.h2`
  font-size: 48px;
  font-weight: 600;
  color: #f44336;
  text-align: center;
  margin: 0;
`;

export const RejectedReason = styled.p`
  font-size: 28px;
  color: #ff7961;
  text-align: center;
  background: rgba(244, 67, 54, 0.1);
  padding: 16px 32px;
  border-radius: 12px;
`;

// ===========================================================================
// ORIENTATION SELECTOR STYLES
// ===========================================================================

export const OrientationSelector = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
`;

export const OrientationLabel = styled.p`
  font-size: 24px;
  color: #b0b0b0;
  margin: 0;
`;

export const OrientationToggle = styled.div`
  display: flex;
  gap: 16px;
`;

export const OrientationOption = styled.button<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 28px;
  border-radius: 12px;
  font-size: 24px;
  font-weight: 500;
  cursor: pointer;
  transition: all 150ms ease-in-out;
  background: ${({ $selected }) =>
    $selected
      ? 'linear-gradient(135deg, #2196f3 0%, #1976d2 100%)'
      : 'rgba(255, 255, 255, 0.05)'};
  color: ${({ $selected }) => ($selected ? '#ffffff' : '#b0b0b0')};
  border: 2px solid
    ${({ $selected }) => ($selected ? '#2196f3' : 'rgba(255, 255, 255, 0.1)')};

  &:hover {
    background: ${({ $selected }) =>
      $selected
        ? 'linear-gradient(135deg, #42a5f5 0%, #2196f3 100%)'
        : 'rgba(255, 255, 255, 0.1)'};
    border-color: ${({ $selected }) =>
      $selected ? '#42a5f5' : 'rgba(255, 255, 255, 0.2)'};
  }

  &:focus {
    transform: scale(1.05);
    box-shadow: 0 0 0 4px rgba(79, 195, 247, 0.3);
  }

  svg {
    width: 28px;
    height: 28px;
    fill: currentColor;
  }
`;

export const AutoBadge = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #4fc3f7;
  background: rgba(79, 195, 247, 0.15);
  padding: 4px 10px;
  border-radius: 6px;
  margin-left: 8px;
`;
